let _source: string | undefined;
let _version: string | undefined;

const init = (source: 'app' | 'web', version: string) => {
  _source = source;
  _version = version;
};

const reset = () => {
  _source = undefined;
  _version = undefined;
};

const get: () => { [key: string]: string } | {} = () => {
  if (!!_source && !!_version) {
    return {
      'x-metadata-source': JSON.stringify({ source: _source, version: _version }),
    };
  }
  return {};
};

export default { init, get, reset };
